import React from 'react';
import { Routes, Route } from 'react-router-dom';

import Home from '../pages/Home';
import MainLayout from '../layout/MainLayout';
import NotFound from '../pages/NotFound';
import Clusters from '../pages/Clusters';
import Products from '../pages/Products';
import ManualMatch from '../pages/ManualMatch';
import Users from '../pages/Users';
import LogoutPage from '../pages/LogoutPage';
// import Login from '../pages/Login';

const AppRoutes = () => (
  <Routes>
    <Route element={<MainLayout />}>
      <Route path="/" element={<Home />} />
      <Route path="/clusters" element={<Clusters />} />
      <Route path="/products" element={<Products />} />
      <Route path="/manualmatch" element={<ManualMatch />} />
      <Route path="/users" element={<Users />} />
    </Route>
    {/* Login non usa il MainLayout per esempio, così non ha la Navbar */}
    {/* <Route path="/login" element={<Login />} /> */}
    <Route path="*" element={<NotFound />} />
    <Route path='/logout' element={<LogoutPage/>}/>
  </Routes>
);

export default AppRoutes;
